module.exports = __webpack_public_path__ + "static/media/icon-BiblioBoard-white.e6e5b1c5.png";